import { Component, Emit, Vue } from 'vue-property-decorator';

@Component
export default class NavigationMenu extends Vue {

    @Emit()
    private close(): void { }
}